import { fetchApi } from "../../tools";

const getCatalogos = async (urlCursos, send, headers, modalidad, idCursoD = 0) => {
  const response = await fetchApi({
    url: urlCursos + "/utils/busquedas",
    headers: headers,
    content: {
      Opcion: "CATALOGOS",
      "Modalidad": modalidad,
      "IdCursoD": idCursoD
    },
  });
  
  return response
  // en el caso de enviar data, se setea el response mediante este metodo "SEND"
};

const postData = async (IdEmp, urlCursos, send, values, headers, idSolicitud, tipo, datosUsuario, datosPhone) => {
  
  const contenido = {
    Nombres: values.Nombres,
    CodDepto: values.CodDepto || datosUsuario.CodDepto || " ",  // ESTO ES TODO, RESOLVER ESTE TEMA, puede ser con otro parametro
    Modalidad: values.Modalidad || datosUsuario.Modalidad,
    Apellidos: values.Apellidos,
    Email: values.Email,
    Cel: values.Cel,
    NIT: datosPhone.dialCode === '502' ? values.NIT || ' ' : ' ',
    NombreDoc: values.NombreDoc || ' ',
    HostName: "DEV07",
    IpHost: "131.107.1.235",
    IdEmp: IdEmp,
    OS: "Windows",
    IdSolicitud: idSolicitud,
    CountryCode: datosPhone.countryCode,
    DialCode: datosPhone.dialCode,
  }

  if (tipo === "NUEVO") {
    delete contenido.IdSolicitud
    delete contenido.Modalidad
    
  }
  
  const response = await fetchApi({
    url: urlCursos + `/inscripciones/solicitud`,
    method: "POST",
    headers: headers,
    content: contenido,
  }).then((data) => {
    
    send("GUARDAR_CARNET", { carnet: data.msg[0].Carnet });
    send("GUARDAR_IDSOLICITUD", { solicitud: data.msg[0].IdSolicitud })    
  }
  );
  // await send('GUARDAR_IDSOLICITUD', { solicitud: response.msg[0].IdSolicitud })
};

const getCursosAsignados = async (urlCursos, headers, values) => { // GUARDAR_CURSOS_ANTES

  const { DPI, Email } = values

  try {
    const response = await fetchApi({
      url: urlCursos + '/utils/busquedas',
      headers: headers,
      content: {
        "Opcion": "CURSOS_ALUMNO",
        "DPI": DPI,
        "Email": Email
      }
    })
    
    return await response.msg
  } catch (error) {
    return await error
  }
}

const validarDPI = async (headers, dpi) => {
  try {
    const res = await fetchApi({
      url: "https://www.imb-pc.com/invoiceapi/utils/cliente_cui",
      headers,
      content: {
        Cui: dpi,
      },
    });
    return { msg: res.msg };
  } catch (err) {
    // console.log(err);
    return { err: err };
  }
};

export { validarDPI, getCatalogos, postData, getCursosAsignados };
// getCursos,
